import React from 'react'
import { SourceEnum } from '@chegg-wt/core/globalTypes'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { connect } from 'react-redux'
import {
  empCitationSearchResultRegion,
  origins,
  Region,
  UserClickPayload,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { SEARCH_RESULT } from '@chegg-wt/core/utils/searchSources'
import { sourceTypeById } from '@chegg-wt/core/utils/sourceTypes'
import { SourceType } from '@chegg-wt/core/types/core'
import SourceToolTip from '../Tooltip/SourceTooltip'
import {
  INVALID_SEARCH_RESULT,
  CREATE_MANUAL_CITATION,
  WEBSITE_SUGGESTION_LINK,
} from './utils/testids'
import * as Styled from './styled'

interface InvalidSearchProps {
  sourceType: SourceType
  onChangeSourceType: (sourceType: SourceType) => void
  onManualCiteClick: (region: Region) => void
  userClick: (payload: UserClickPayload) => void
}
const InvalidSearch: React.FC<InvalidSearchProps> = ({
  sourceType,
  onChangeSourceType,
  onManualCiteClick,
  userClick,
}) => {
  return (
    <Styled.EmptyContainer data-test={INVALID_SEARCH_RESULT}>
      <Styled.LoadingDescription>
        <Styled.Heading role="alert">
          Are you looking for a{' '}
          <Styled.LinkText
            data-test={WEBSITE_SUGGESTION_LINK}
            onClick={() => {
              onChangeSourceType(sourceTypeById(SourceEnum.website))
              userClick({ origin: origins.lookForWebsiteAfterSearchResult })
            }}
          >
            website
          </Styled.LinkText>
          ?
        </Styled.Heading>

        <Styled.NoResultBody>
          If you’re looking for a {sourceType?.id}, try searching by title or{' '}
          <SourceToolTip sourceType={sourceType} location={SEARCH_RESULT} />. You can also{' '}
          <Styled.LinkText
            data-test={CREATE_MANUAL_CITATION}
            onClick={() => {
              onManualCiteClick(empCitationSearchResultRegion)
            }}
          >
            create a manual citation
          </Styled.LinkText>
          .
        </Styled.NoResultBody>
      </Styled.LoadingDescription>
    </Styled.EmptyContainer>
  )
}

const mapDispatchToProps = {
  userClick,
}

export default connect(null, mapDispatchToProps)(InvalidSearch)
